import React, { Component } from 'react';
import '../styles/Button.css';

class Button extends Component {
    render() {
        return (
            <div className={this.props.className + ' btn'} style={this.props.style} onClick={this.props.onClick}>
            </div>
        )
    }
}

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js